import {Component, OnInit} from '@angular/core';
import {DialogConfig} from "../../../../../core/components/dialog/dialog-config";
import {DialogRef} from "../../../../../core/components/dialog/dialog-ref";
import {DocumentoAllegato} from "../../../../models/documento-allegato";

@Component({
  selector: 'app-sign-document-dialog',
  templateUrl: './sign-document-dialog.component.html',
  styleUrls: ['./sign-document-dialog.component.css']
})
export class SignDocumentDialogComponent implements OnInit {

  protected document: DocumentoAllegato

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef
  ) {
  }

  public ngOnInit() {
    console.log("[ngOnInit]");
    this.document = this.dialogConfig.data.document;
  }

  protected doClose() {
    this.dialogRef.close({modalEvent : true});
  }

}
